<!-- Edit.vue -->
<template>
  <div class="main-content">
    <div class="card p-2">
      <div class="mb-2 bread">
        Fila de flow <span class="sep2">›</span> Editar solicitação
      </div>

      <div class="d-flex justify-content-between align-items-center mb-3">
        <h4 class="m-0 page-title">Editar solicitação</h4>

        <div class="bell-wrap" ref="bellWrap">
          <button
            class="btn btn-sm btn-outline-secondary bell-btn"
            @click="toggleNotificationsPanel"
          >
            <i class="fa fa-bell"></i>
            <span v-if="flowNotifications.length" class="bell-badge">
              {{ flowNotifications.length }}
            </span>
          </button>

          <div v-if="showNotificationsPanel" class="bell-panel">
            <div class="bell-head">
              <span>Notificações do fluxo</span>
            </div>

            <div v-if="!flowNotifications.length" class="bell-empty">
              Nenhuma notificação registrada.
            </div>

            <div v-else class="bell-list">
              <div
                v-for="n in flowNotifications"
                :key="'flow_notif_' + n.id"
                class="notif-item"
              >
                <div class="notif-title">
                  {{ n.notified_user_name || n.department_name || "—" }}
                  <span v-if="n.transition_name"> · {{ n.transition_name }}</span>
                </div>
                <div class="notif-meta">
                  {{ n.reason }} — {{ formatDate(n.created_at) }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Modal de Alterar Responsável -->
      <div
        class="modal fade"
        id="flowResponsibleModal"
        tabindex="-1"
        role="dialog"
        aria-hidden="true"
      >
        <div class="modal-dialog modal-md" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Alterar Responsável</h5>
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                @click="closeResponsibleBox"
              >
                <span>&times;</span>
              </button>
            </div>

            <div class="modal-body">
              <label class="modal-label">Selecione o novo responsável</label>

              <v-select
                v-model="selectedResponsibleUserId"
                :options="responsibleOptions"
                :reduce="(u) => u.id"
                label="name"
              ></v-select>
            </div>

            <div class="modal-footer">
              <button
                class="btn btn-secondary"
                data-dismiss="modal"
                @click="closeResponsibleBox"
              >
                Cancelar
              </button>
              <button
                class="btn btn-primary"
                data-dismiss="modal"
                :disabled="assigningResponsible"
                @click="currentStep && saveResponsibleBox(currentStep)"
              >
                Alterar
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- Modal de Formulário da Etapa -->
      <div
        class="modal fade"
        id="stepAnswerModal"
        tabindex="-1"
        role="dialog"
        aria-hidden="true"
      >
        <div class="modal-dialog modal-md" role="document">
          <div class="modal-content" v-if="currentStepForm">
            <div class="modal-header">
              <h5 class="modal-title">
                Formulário — {{ currentStep ? stepTitle(currentStep) : "" }}
              </h5>
              <button type="button" class="close" data-dismiss="modal">
                <span>&times;</span>
              </button>
            </div>

            <div class="modal-body">
              <p v-if="currentStepForm.form_required" class="form-required-note">
                <i class="fa fa-exclamation-circle"></i>
                Este formulário precisa ser respondido para concluir a etapa.
              </p>

              <div
                v-for="q in currentStepForm.questions"
                :key="q.id"
                class="answer-question"
              >
                <label class="modal-label">
                  {{ q.label }}
                  <span v-if="q.required" class="req">*</span>
                </label>

                <input
                  v-if="q.field_type === 'text'"
                  v-model="stepAnswerValues[q.id]"
                  class="form-control"
                  type="text"
                />

                <div v-else-if="q.field_type === 'boolean'" class="d-flex" style="gap: 16px">
                  <label class="radio-inline">
                    <input
                      type="radio"
                      :name="'q_' + q.id"
                      :value="true"
                      v-model="stepAnswerValues[q.id]"
                    />
                    Sim
                  </label>
                  <label class="radio-inline">
                    <input
                      type="radio"
                      :name="'q_' + q.id"
                      :value="false"
                      v-model="stepAnswerValues[q.id]"
                    />
                    Não
                  </label>
                </div>

                <select
                  v-else-if="q.field_type === 'select'"
                  v-model="stepAnswerValues[q.id]"
                  class="form-control"
                >
                  <option value="" disabled>Selecione...</option>
                  <option v-for="opt in q.options" :key="opt" :value="opt">
                    {{ opt }}
                  </option>
                </select>

                <div v-else-if="q.field_type === 'file'">
                  <div v-if="q.answer && q.answer.file" class="mb-1">
                    <a href="#" @click.prevent="openExistingFile(q.answer.file)">
                      <i class="fa fa-paperclip"></i>
                      {{ q.answer.file.original_name }}
                    </a>
                    (envie outro arquivo abaixo para substituir)
                  </div>
                  <input
                    type="file"
                    class="form-control"
                    @change="onAnswerFileChange(q, $event)"
                  />
                </div>
              </div>

              <div v-if="stepAnswerError" class="alert alert-danger mt-2 p-2">
                {{ stepAnswerError }}
              </div>
            </div>

            <div class="modal-footer">
              <button class="btn btn-secondary" data-dismiss="modal">
                Fechar
              </button>
              <button
                class="btn btn-primary"
                :disabled="savingStepAnswers"
                @click="saveStepAnswers"
              >
                {{ savingStepAnswers ? "Salvando..." : "Salvar respostas" }}
              </button>
            </div>
          </div>
        </div>
      </div>

      <div v-if="error" class="alert alert-danger p-2 mb-3">
        {{ error }}
      </div>

      <div
        v-if="flow && flow.status === 'cancelled'"
        class="alert alert-warning p-3 mb-3"
      >
        <i class="fa fa-ban"></i>
        <strong> Fluxo cancelado.</strong> Esta solicitação foi cancelada e não
        pode mais ser movimentada.
        <span v-if="flow.cancelled_by_name || flow.cancelled_at">
          — Cancelado por <strong>{{ flow.cancelled_by_name || "—" }}</strong>
          <span v-if="flow.cancelled_at">
            em {{ formatDate(flow.cancelled_at) }}</span
          >.
        </span>
      </div>

      <!-- HEADER -->
      <div class="header-card">
        <div class="header-top">
          <div class="header-top-main">
            <p class="flow-name">{{ flow.title || "—" }}</p>
            <span
              class="flow-status-badge"
              :class="'fs-' + (flow.status || 'in_progress')"
            >
              {{ flowStatusLabel }}
            </span>
          </div>
          <span v-if="flow.tag" class="tag-pill">{{ flow.tag }}</span>
        </div>

        <div class="info-grid">
          <div class="info-chip">
            <i class="fa fa-sitemap"></i>
            <div class="info-chip-text">
              <span class="info-label">Área responsável</span>
              <span class="info-value">{{ ownerDepartmentName }}</span>
            </div>
          </div>
          <div class="info-chip">
            <i class="fa fa-user"></i>
            <div class="info-chip-text">
              <span class="info-label">Aberto por</span>
              <span class="info-value">{{ openedByName }}</span>
            </div>
          </div>
          <div class="info-chip">
            <i class="fa fa-calendar"></i>
            <div class="info-chip-text">
              <span class="info-label">Abertura</span>
              <span class="info-value">{{ formatDate(flow.created_at) }}</span>
            </div>
          </div>
        </div>

        <div v-if="initialDescription" class="header-description">
          <span class="header-description-label">Descrição da abertura</span>
          <p class="header-description-text">{{ initialDescription }}</p>
        </div>

        <div v-if="currentStep" class="header-responsible-row">
          <div class="info-chip">
            <i class="fa fa-user-o"></i>
            <div class="info-chip-text">
              <span class="info-label">Responsável — etapa atual</span>
              <span class="info-value">
                {{ stepResponsibleName(currentStep, steps.indexOf(currentStep)) }}
              </span>
            </div>
          </div>

          <div v-if="canFinalizeCurrentStep" class="header-responsible-actions">
            <button
              v-if="!currentStep.responsible_user_id"
              class="btn btn-outline-success btn-sm"
              @click="assignMeAsResponsible(currentStep)"
            >
              Tomar posse
            </button>
            <button
              class="btn btn-outline-primary btn-sm"
              @click="openResponsibleBox(currentStep)"
            >
              Alterar responsável
            </button>
          </div>
        </div>

        <div class="progress-wrap">
          <div class="progress-labels">
            <span>{{ doneStepsCount }} de {{ steps.length }} etapas concluídas</span>
            <span class="progress-percent">{{ progressPercent }}%</span>
          </div>
          <div class="progress-track">
            <div
              class="progress-fill"
              :class="'pf-' + (flow.status || 'in_progress')"
              :style="{ width: progressPercent + '%' }"
            ></div>
          </div>
          <div class="progress-current">
            Etapa atual: <b>{{ currentStep ? stepTitle(currentStep) : "—" }}</b>
          </div>
        </div>

        <div class="legend">
          <div class="legend-item"><span class="dot dot-done"></span>Concluída</div>
          <div class="legend-item"><span class="dot dot-current"></span>Em andamento</div>
          <div class="legend-item">
            <span class="dot dot-warn"></span>Com pendência
          </div>
          <div class="legend-item"><span class="dot dot-locked"></span>Bloqueada</div>
        </div>
      </div>

      <!-- TIMELINE -->
      <div class="header-card">
        <div class="timeline">
          <div v-for="(s, idx) in steps" :key="s.uid" class="tl-step">
            <div class="rail">
              <div class="node" :class="stepStateClass(s)">
                <i v-if="isDone(s) && !s.left_pending" class="fa fa-check"></i>
                <span v-else>{{ idx + 1 }}</span>
              </div>
              <div
                v-if="idx < steps.length - 1"
                class="connector"
                :class="stepStateClass(s)"
              ></div>
            </div>

            <div class="tl-body">
              <div class="tl-card" :class="stepStateClass(s)">
                <div class="tl-head">
                  <div>
                    <p class="tl-title">
                      {{ stepTitle(s) }}
                      <span v-if="isCurrent(s)" class="pill-next">Etapa Atual</span>
                    </p>
                    <span class="tl-area">{{ s.department_name || "—" }}</span>
                  </div>
                  <span class="status-pill" :class="stepStateClass(s)">
                    {{ statusLabel(s) }}
                  </span>
                </div>

                <div class="tl-info-row">
                  <span class="tl-info-chip">
                    <i class="fa fa-user-circle-o"></i>
                    {{ stepResponsibleName(s, idx) }}
                  </span>
                  <span
                    v-if="isDone(s) && stepCompletedMeta(s)"
                    class="tl-info-chip tl-info-chip-done"
                  >
                    <i class="fa fa-check-circle"></i>
                    {{ idx === 0 ? "Aberto por" : "Finalizado por" }}
                    {{ stepCompletedMeta(s).user_name || "—" }}
                    <template v-if="stepCompletedMeta(s).created_at">
                      · {{ formatDate(stepCompletedMeta(s).created_at) }}
                    </template>
                  </span>
                </div>

                <div
                  v-if="s.form && s.form.questions && s.form.questions.length"
                  class="tl-form-summary"
                >
                  <div class="tl-form-title">
                    <i class="fa fa-list-alt"></i> Formulário da etapa
                    <span v-if="s.form.form_required" class="tl-form-req-tag">
                      Obrigatório
                    </span>
                  </div>

                  <div
                    v-for="q in s.form.questions"
                    :key="q.id"
                    class="tl-form-row"
                  >
                    <span class="tl-form-q">
                      <i :class="'fa ' + questionTypeIcon(q.field_type)"></i>
                      {{ q.label }}
                    </span>

                    <a
                      v-if="q.field_type === 'file' && q.answer && q.answer.file"
                      href="#"
                      class="tl-form-a-file"
                      @click.prevent="openExistingFile(q.answer.file)"
                    >
                      <i class="fa fa-paperclip"></i> {{ formatAnswer(q) }}
                    </a>
                    <span
                      v-else-if="q.field_type === 'boolean' && q.answer && q.answer.value_boolean !== null && q.answer.value_boolean !== undefined"
                      class="tl-form-a-bool"
                      :class="q.answer.value_boolean ? 'is-yes' : 'is-no'"
                    >
                      {{ formatAnswer(q) }}
                    </span>
                    <span
                      v-else
                      class="tl-form-a"
                      :class="{ 'is-empty': formatAnswer(q) === '—' }"
                    >
                      {{ formatAnswer(q) }}
                    </span>
                  </div>
                </div>

                <div v-if="s.left_pending" class="guidance">
                  <span><i class="fa fa-exclamation-triangle"></i></span>
                  <span>
                    <b>Avançada sem conclusão.</b> Ficou pendência registrada
                    nesta etapa.
                  </span>
                </div>

                <div v-if="hasPendingPredecessor(s)" class="guidance">
                  <span><i class="fa fa-exclamation-triangle"></i></span>
                  <span>
                    <b>Aberta antes da conclusão da etapa anterior.</b>
                    Verifique as orientações registradas lá antes de
                    prosseguir.
                  </span>
                </div>

                <div
                  v-if="isCurrent(s) && stepFormRequiredIncomplete"
                  class="guidance"
                >
                  <span><i class="fa fa-list-alt"></i></span>
                  <span>
                    <b>Formulário obrigatório pendente.</b>
                    Responda as perguntas desta etapa para poder concluí-la.
                  </span>
                </div>

                <!-- Painel de Aprovação inline -->
                <div
                  v-if="isCurrent(s) && s.requires_approval"
                  class="approval-inline"
                >
                  <div class="tl-meta">
                    Status da aprovação:
                    <b>{{ approvalStatusLabel }}</b>
                  </div>
                  <div class="tl-meta">
                    Aprovador: <b>{{ approvalApproverName }}</b>
                  </div>

                  <div v-if="canShowApprovalActions" class="tl-actions">
                    <button
                      class="btn btn-success btn-sm"
                      :disabled="saving"
                      @click="approveFlow"
                    >
                      <i class="fa fa-check"></i> Aprovar
                    </button>
                    <button
                      class="btn btn-danger btn-sm"
                      :disabled="saving"
                      @click="openRejectBox"
                    >
                      <i class="fa fa-times"></i> Rejeitar
                    </button>
                  </div>

                  <div v-if="showRejectBox" class="reject-box mt-2">
                    <label class="lbl">Motivo da reprovação</label>
                    <textarea
                      v-model="rejectForm.comment"
                      class="form-control text-area-sm"
                      rows="3"
                      placeholder="Digite o motivo da reprovação..."
                    ></textarea>

                    <div class="mt-2">
                      <label class="lbl">Tipo da reprovação</label>
                      <select
                        v-model="rejectForm.rejection_type"
                        class="form-control"
                      >
                        <option value="step">Voltar para uma etapa</option>
                        <option value="global">Reprovar fluxo inteiro</option>
                      </select>
                    </div>

                    <div class="mt-2" v-if="rejectForm.rejection_type === 'step'">
                      <label class="lbl">Retornar para etapa</label>
                      <select
                        v-model="rejectForm.return_to_transition_id"
                        class="form-control"
                      >
                        <option value="" disabled>Selecione a etapa</option>
                        <option
                          v-for="step in returnStepOptions"
                          :key="'return_' + step.id"
                          :value="step.id"
                        >
                          Etapa {{ step.step_order }} — {{ step.name }}
                        </option>
                      </select>
                    </div>

                    <div class="d-flex justify-content-end mt-2" style="gap: 10px">
                      <button
                        class="btn btn-outline-secondary btn-sm"
                        :disabled="saving"
                        @click="cancelRejectBox"
                      >
                        Cancelar
                      </button>
                      <button
                        class="btn btn-danger btn-sm"
                        :disabled="saving"
                        @click="confirmRejectFlow"
                      >
                        Confirmar Rejeição
                      </button>
                    </div>
                  </div>
                </div>

                <div v-if="isFutureStep(s)" class="locked-note">
                  Aguardando a conclusão da etapa anterior.
                </div>

                <div v-else class="tl-actions">
                  <button
                    v-if="isCurrent(s) && currentStepForm"
                    class="btn btn-outline-primary btn-sm"
                    @click="openStepAnswerModal"
                  >
                    <i class="fa fa-list-alt"></i> Responder formulário
                  </button>

                  <button
                    v-if="isCurrent(s) && !s.requires_approval && canFinalizeCurrentStep"
                    class="btn btn-primary btn-sm"
                    :disabled="saving || stepFormRequiredIncomplete"
                    :title="stepFormRequiredIncomplete ? 'Responda o formulário obrigatório da etapa antes de concluir.' : ''"
                    @click="finalizeCurrentStep"
                  >
                    Concluir etapa
                  </button>

                  <button
                    v-if="isCurrent(s) && !s.requires_approval && canFinalizeCurrentStep && !isLastStep"
                    class="btn btn-warning btn-sm"
                    :disabled="saving"
                    @click="advanceWithPending"
                  >
                    Avançar sem concluir
                  </button>

                  <button
                    v-if="canReopenStep(s)"
                    class="btn btn-outline-secondary btn-sm"
                    :disabled="saving"
                    @click="reopenStep(s)"
                  >
                    <i class="fa fa-undo"></i> Reabrir etapa
                  </button>
                </div>

                <!-- Thread de comentários -->
                <div v-if="idx !== 0 && !isFutureStep(s)" class="thread">
                  <div class="thread-toggle" @click="toggleStepThread(s)">
                    <span>{{ isStepThreadOpen(s) ? "▾" : "▸" }} Comentários</span>
                    <span class="count">{{ stepHistoryItems(s).length }}</span>
                  </div>

                  <div v-if="isStepThreadOpen(s)" class="thread-body">
                    <div
                      v-for="item in stepHistoryItems(s)"
                      :key="item.type + '_' + item.id"
                      class="tl-comment"
                    >
                      <div class="avatar">{{ initials(item.user_name) }}</div>
                      <div class="tl-comment-main">
                        <div class="tl-comment-head">
                          <span class="tl-comment-author">{{ item.user_name || "—" }}</span>
                          <span class="tl-comment-time" v-if="item.created_at">
                            {{ formatDate(item.created_at) }}
                          </span>
                        </div>
                        <div v-if="item.type === 'comment'" class="tl-comment-text">
                          {{ item.text }}
                        </div>
                        <div
                          v-else
                          class="attachment-chip file-link"
                          @click="openExistingFile(item)"
                        >
                          <i class="fa fa-paperclip"></i> {{ item.original_name }}
                        </div>
                      </div>
                    </div>

                    <div v-if="isCurrent(s)" class="new-comment">
                      <textarea
                        v-model="finishForm.description"
                        class="form-control"
                        rows="3"
                        placeholder="Escreva uma atualização ou observação sobre esta etapa..."
                      ></textarea>

                      <div class="nc-actions">
                        <div class="nc-attach-preview">
                          <button
                            class="btn btn-outline-secondary btn-sm"
                            type="button"
                            @click="openFinishPicker"
                          >
                            <i class="fa fa-paperclip"></i> Anexar
                          </button>
                          <input
                            ref="finishFile"
                            type="file"
                            class="d-none"
                            multiple
                            @change="handleFinishFiles"
                          />
                          <span
                            v-for="(f, idx) in finishForm.files"
                            :key="'finish_' + idx"
                            class="nc-file-chip"
                          >
                            {{ f.name }}
                            <span class="remove" @click="removeFinishFile(idx)">remover</span>
                          </span>
                        </div>

                        <button
                          class="btn btn-outline-primary btn-sm"
                          :disabled="saving"
                          @click="saveCurrentUpdate"
                        >
                          Salvar atualização
                        </button>
                      </div>

                      <div v-if="pdfError" class="alert alert-danger mt-2 p-2">
                        {{ pdfError }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="form-footer">
        <button
          class="btn btn-outline-secondary"
          :disabled="saving"
          @click="cancel"
        >
          Voltar
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      error: "",
      saving: false,

      flow: {},
      steps: [],
      currentStepOrder: 1,

      departments: [],
      departmentsById: {},

      pdfError: "",
      existingFiles: [],

      currentUserDepartmentIds: [],

      responsibleBoxStepUid: null,
      responsibleOptions: [],
      selectedResponsibleUserId: null,
      assigningResponsible: false,

      currentApproval: null,
      historyByStep: [],
      threadOpen: {},

      showRejectBox: false,
      rejectForm: {
        comment: "",
        rejection_type: "step",
        return_to_transition_id: "",
      },

      finishForm: {
        description: "",
        files: [],
      },

      flowNotifications: [],
      showNotificationsPanel: false,

      currentStepForm: null,
      stepAnswerValues: {},
      stepAnswerFiles: {},
      savingStepAnswers: false,
      stepAnswerError: "",
    };
  },

  computed: {
    openedByName() {
      if (this.flow?.openedBy?.name) return this.flow.openedBy.name;
      if (this.flow?.opened_by_name) return this.flow.opened_by_name;
      return "—";
    },

    ownerDepartmentName() {
      if (this.flow?.ownerDepartment?.name) return this.flow.ownerDepartment.name;
      return this.deptName(this.flow.owner_department_id);
    },

    initialDescription() {
      return this.flow?.initial_description || this.flow?.description || "";
    },

    currentStep() {
      return (
        this.steps.find((s) => (s.step_order || 0) === this.currentStepOrder) ||
        null
      );
    },

    currentStepRequiresApproval() {
      return !!this.currentStep?.requires_approval;
    },

    isLastStep() {
      return !this.steps.some(
        (s) => (s.step_order || 0) > this.currentStepOrder
      );
    },

    doneStepsCount() {
      return this.steps.filter((s) => this.isDone(s)).length;
    },

    progressPercent() {
      if (!this.steps.length) return 0;
      return Math.round((this.doneStepsCount / this.steps.length) * 100);
    },

    approvalStatusLabel() {
      const status = this.currentApproval?.status;

      if (!status) return "—";
      if (status === "pending") return "Pendente";
      if (status === "approved") return "Aprovado";
      if (status === "rejected") return "Rejeitado";

      return status;
    },

    approvalApproverName() {
      return (
        this.currentApproval?.approver_name ||
        this.currentStep?.approver_name ||
        "—"
      );
    },

    canShowApprovalActions() {
      return (
        this.currentStepRequiresApproval &&
        this.currentApproval?.status === "pending"
      );
    },

    canFinalizeCurrentStep() {
      if (!this.currentStep) return false;
      const deptId = this.currentStep.department_id;
      if (!deptId) return true; // no department restriction
      return this.currentUserDepartmentIds.includes(Number(deptId));
    },

    returnStepOptions() {
      return this.steps.filter(
        (s) => (s.step_order || 0) < this.currentStepOrder
      );
    },

    flowStatusLabel() {
      const map = {
        in_progress: "Em andamento",
        waiting_approval: "Aguardando aprovação",
        done: "Concluído",
        done_with_pending: "Concluído com pendência",
        rejected: "Rejeitado",
        cancelled: "Cancelado",
      };
      return map[this.flow.status] || "Em andamento";
    },

    stepFormRequiredIncomplete() {
      if (!this.currentStepForm || !this.currentStepForm.form_required) {
        return false;
      }

      return this.currentStepForm.questions
        .filter((q) => q.required)
        .some((q) => !this.isQuestionAnswered(q));
    },
  },

  async mounted() {
    await this.loadMeta();
    await this.loadFlow();
    await this.loadNotifications();
    document.addEventListener("click", this.handleOutsideBellClick);
  },

  beforeDestroy() {
    document.removeEventListener("click", this.handleOutsideBellClick);
  },

  methods: {
    initials(name) {
      if (!name) return "—";
      return name
        .split(" ")
        .map((w) => w[0])
        .filter(Boolean)
        .slice(0, 2)
        .join("")
        .toUpperCase();
    },

    isFutureStep(s) {
      return !this.isDone(s) && !this.isCurrent(s);
    },

    stepResponsibleName(step, idx) {
      if (step.responsible_name) return step.responsible_name;
      if (idx === 0) return this.openedByName;
      return "Não atribuído";
    },

    statusLabel(s) {
      if (this.isDone(s)) {
        return s.left_pending ? "Concluída com pendência" : "Concluída";
      }
      if (this.isCurrent(s)) {
        return this.hasPendingPredecessor(s)
          ? "Andamento com pendência"
          : "Em andamento";
      }
      return "Bloqueada";
    },

    hasPendingPredecessor(step) {
      const idx = this.steps.findIndex((s) => s.uid === step.uid);
      if (idx <= 0) return false;
      return !!this.steps[idx - 1].left_pending;
    },

    canReopenStep(step) {
      if ((step.step_order || 0) === 1) return false; // Abertura não é reaberta
      if (["rejected", "cancelled"].includes(this.flow.status)) return false;

      if (step.left_pending) return true;

      if (this.flow.status === "done" || this.flow.status === "done_with_pending") {
        return (step.step_order || 0) === this.currentStepOrder;
      }

      return (step.step_order || 0) === this.currentStepOrder - 1;
    },

    isStepThreadOpen(step) {
      return !!this.threadOpen[step.uid];
    },

    toggleStepThread(step) {
      this.$set(this.threadOpen, step.uid, !this.threadOpen[step.uid]);
    },

    stepHistoryItems(step) {
      const found = this.historyByStep.find(
        (h) => (h.step_order || 0) === (step.step_order || 0)
      );
      return found ? found.items : [];
    },

    toggleNotificationsPanel() {
      this.showNotificationsPanel = !this.showNotificationsPanel;
    },

    handleOutsideBellClick(e) {
      if (
        this.showNotificationsPanel &&
        this.$refs.bellWrap &&
        !this.$refs.bellWrap.contains(e.target)
      ) {
        this.showNotificationsPanel = false;
      }
    },

    async loadNotifications() {
      try {
        const apiBase = this.$store.state.api;
        const id = this.$route.params.id;
        const res = await this.$http.get(
          apiBase + "flows/" + id + "/notifications"
        );
        this.flowNotifications = Array.isArray(res.data) ? res.data : [];
      } catch (e) {
        console.error(e);
      }
    },

    async advanceWithPending() {
      if (this.saving) return;

      try {
        this.saving = true;
        this.error = "";

        const id = this.$route.params.id;
        const apiBase = this.$store.state.api;

        const fd = new FormData();
        fd.append("new_description", this.finishForm.description || "");
        for (const f of this.finishForm.files) {
          fd.append("attachments[]", f);
        }

        await this.$http.post(apiBase + "flows/" + id + "/complement", fd, {
          headers: { "Content-Type": "multipart/form-data" },
        });

        await this.$http.post(apiBase + "flows/" + id + "/advance", {
          left_pending: true,
        });

        this.finishForm = { description: "", files: [] };
        this.pdfError = "";

        await this.loadFlow();
        await this.loadNotifications();
        swal(
          "Etapa avançada",
          "A etapa foi avançada sem conclusão e ficou registrada como pendência.",
          "warning"
        );
      } catch (e) {
        console.error("ADVANCE PENDING ERROR:", e?.response || e);
        this.error =
          e?.response?.data?.message || "Erro ao avançar a etapa.";
      } finally {
        this.saving = false;
      }
    },

    async reopenStep(step) {
      if (this.saving) return;

      const confirmed = await swal({
        title: "Reabrir etapa?",
        text:
          'A etapa "' + (step.name || "") + '" voltará a ficar em andamento.',
        icon: "warning",
        buttons: ["Não", "Sim, reabrir"],
      });

      if (!confirmed) return;

      try {
        this.saving = true;
        this.error = "";

        const id = this.$route.params.id;
        const apiBase = this.$store.state.api;

        await this.$http.post(apiBase + "flows/" + id + "/reopen", {
          transition_id: step.id,
        });

        await this.loadFlow();
        await this.loadNotifications();
        swal("Sucesso", "Etapa reaberta.", "success");
      } catch (e) {
        console.error("REOPEN ERROR:", e?.response || e);
        this.error = e?.response?.data?.message || "Erro ao reabrir a etapa.";
      } finally {
        this.saving = false;
      }
    },

    async loadMeta() {
      try {
        const apiBase = this.$store.state.api;
        const depsRes = await this.$http.get(
          apiBase + "departments?paginated=false"
        );

        this.departments = depsRes.data.data || [];
        this.departmentsById = this.departments.reduce((acc, d) => {
          acc[d.id] = d.name || d.description || `#${d.id}`;
          return acc;
        }, {});
      } catch (e) {
        console.error(e);
      }
    },

    formatDate(iso) {
      if (!iso) return "—";
      const d = new Date(iso);
      if (isNaN(d.getTime())) return iso;
      return d.toLocaleString("pt-BR");
    },

    deptName(id) {
      if (!id) return "—";
      return this.departmentsById[id] || `#${id}`;
    },

    getLoggedUserId() {
      return this.$store?.state?.user?.id || null;
    },

    canManageResponsible(step) {
      if (!this.isCurrent(step)) return false;
      return this.canFinalizeCurrentStep;
    },

    async assignMeAsResponsible(step) {
      await this.saveResponsibleFor(step, this.getLoggedUserId());
    },

    async openResponsibleBox(step) {
      this.responsibleBoxStepUid = step.uid;
      this.selectedResponsibleUserId = step.responsible_user_id || null;
      this.responsibleOptions = [];

      try {
        const apiBase = this.$store.state.api;
        const res = await this.$http.get(
          apiBase + "flow-transitions/" + step.id + "/department-users"
        );
        this.responsibleOptions = res.data || [];
      } catch (e) {
        console.error(e);
        this.$message(
          null,
          e?.response?.data || "Não consegui carregar as pessoas do departamento.",
          "error"
        );
      }

      $("#flowResponsibleModal").modal("show");
    },

    closeResponsibleBox() {
      this.responsibleBoxStepUid = null;
      this.selectedResponsibleUserId = null;
      this.responsibleOptions = [];
    },

    async saveResponsibleBox(step) {
      await this.saveResponsibleFor(step, this.selectedResponsibleUserId);
    },

    async saveResponsibleFor(step, responsibleUserId) {
      if (!responsibleUserId) {
        this.$message(null, "Selecione uma pessoa responsável.", "error");
        return;
      }

      if (this.assigningResponsible) return;
      this.assigningResponsible = true;

      try {
        const apiBase = this.$store.state.api;
        await this.$http.post(
          apiBase + "flows/" + this.flow.id + "/transitions/" + step.id + "/responsible",
          { responsible_user_id: responsibleUserId }
        );

        this.closeResponsibleBox();
        await this.loadFlow();
        await this.loadNotifications();
      } catch (e) {
        console.error(e);
        this.$message(
          null,
          e?.response?.data?.message || e?.response?.data || "Não consegui definir o responsável.",
          "error"
        );
      } finally {
        this.assigningResponsible = false;
      }
    },

    isQuestionAnswered(question) {
      const answer = question.answer;
      if (!answer) return false;
      if (question.field_type === "boolean") return answer.value_boolean !== null;
      if (question.field_type === "file") return !!answer.flow_file_id;
      return !!(answer.value_text && String(answer.value_text).trim());
    },

    async loadCurrentStepForm() {
      this.currentStepForm = null;
      this.stepAnswerValues = {};
      this.stepAnswerFiles = {};

      const form = this.currentStep && this.currentStep.form;
      if (!form) return;

      this.currentStepForm = form;

      const values = {};
      form.questions.forEach((q) => {
        if (!q.answer) return;
        if (q.field_type === "boolean") values[q.id] = q.answer.value_boolean;
        else if (q.field_type !== "file") values[q.id] = q.answer.value_text;
      });
      this.stepAnswerValues = values;

      if (this.stepFormRequiredIncomplete) {
        this.openStepAnswerModal();
      }
    },

    questionTypeIcon(fieldType) {
      const map = {
        text: "fa-align-left",
        boolean: "fa-check-square-o",
        select: "fa-list-ul",
        file: "fa-paperclip",
      };
      return map[fieldType] || "fa-question-circle";
    },

    formatAnswer(question) {
      const answer = question.answer;
      if (!answer) return "—";

      if (question.field_type === "boolean") {
        if (answer.value_boolean === null || answer.value_boolean === undefined) {
          return "—";
        }
        return answer.value_boolean ? "Sim" : "Não";
      }

      if (question.field_type === "file") {
        return answer.file ? answer.file.original_name : "—";
      }

      return answer.value_text && String(answer.value_text).trim()
        ? answer.value_text
        : "—";
    },

    openStepAnswerModal() {
      this.stepAnswerError = "";
      $("#stepAnswerModal").modal("show");
    },

    onAnswerFileChange(question, e) {
      const file = (e.target.files || [])[0] || null;
      this.$set(this.stepAnswerFiles, question.id, file);
    },

    async saveStepAnswers() {
      if (!this.currentStepForm || this.savingStepAnswers) return;

      this.stepAnswerError = "";
      this.savingStepAnswers = true;

      try {
        const apiBase = this.$store.state.api;
        const fd = new FormData();

        this.currentStepForm.questions.forEach((q, idx) => {
          fd.append(`answers[${idx}][question_id]`, q.id);

          if (q.field_type === "file") {
            const file = this.stepAnswerFiles[q.id];
            if (file) fd.append(`answers[${idx}][file]`, file);
          } else {
            const value = this.stepAnswerValues[q.id];
            fd.append(`answers[${idx}][value]`, value === undefined || value === null ? "" : value);
          }
        });

        await this.$http.post(
          apiBase +
            "flow-transitions/" +
            this.currentStepForm.flow_transition_id +
            "/form/answers",
          fd,
          { headers: { "Content-Type": "multipart/form-data" } }
        );

        $("#stepAnswerModal").modal("hide");
        await this.loadCurrentStepForm();
      } catch (e) {
        console.error("SAVE STEP ANSWERS ERROR:", e?.response || e);
        this.stepAnswerError =
          e?.response?.data?.message || "Não consegui salvar as respostas.";
      } finally {
        this.savingStepAnswers = false;
      }
    },

    stepNameByOrder(stepOrder) {
      const found = this.steps.find((s) => (s.step_order || 0) === stepOrder);
      return found?.name || `Etapa ${stepOrder}`;
    },

    async loadFlow() {
      try {
        this.error = "";
        const id = this.$route.params.id;
        const apiBase = this.$store.state.api;

        const res = await this.$http.get(apiBase + "flows/" + id);
        const data = res.data;

        this.flow = data || {};
        this.existingFiles = Array.isArray(this.flow.files)
          ? this.flow.files
          : [];
        this.currentApproval = this.flow.current_approval || null;

        const transitions = Array.isArray(this.flow.transitions)
          ? this.flow.transitions
          : [];

        this.steps = transitions
          .slice()
          .sort((a, b) => (a.step_order || 0) - (b.step_order || 0))
          .map((t) => {
            const depName =
              t.department && t.department.name
                ? t.department.name
                : this.deptName(t.department_id);

            return {
              uid: "t_" + (t.id || Math.random().toString(16).slice(2)),
              id: t.id || null,
              step_order: t.step_order,
              name: t.name,
              department_id: t.department_id,
              department_name: depName,
              requires_approval: !!t.requires_approval,
              approver_user_id: t.approver_user_id || null,
              approver_name:
                t.approver && t.approver.name ? t.approver.name : null,
              responsible_user_id: t.responsible_user_id || null,
              responsible_name:
                t.responsible && t.responsible.name ? t.responsible.name : null,
              left_pending: !!t.left_pending,
              finished_at: t.finished_at || null,
              form: t.form || null,
            };
          });

        this.currentStepOrder = this.flow.current_step_order || 1;
        this.currentUserDepartmentIds = Array.isArray(
          data.current_user_department_ids
        )
          ? data.current_user_department_ids.map(Number)
          : [];
        this.buildHistoryByStep();
        await this.loadCurrentStepForm();
      } catch (e) {
        console.error("LOAD FLOW ERROR:", e?.response || e);
        this.error =
          e?.response?.data?.message ||
          e?.response?.data?.error ||
          JSON.stringify(e?.response?.data) ||
          "Não consegui carregar as informações.";
      }
    },

    ensureHistoryStep(stepMap, stepOrder) {
      if (!stepMap[stepOrder]) {
        stepMap[stepOrder] = {
          step_order: stepOrder,
          step_name: this.stepNameByOrder(stepOrder),
          items: [],
        };
      }

      return stepMap[stepOrder];
    },

    buildHistoryByStep() {
      const stepMap = {};
      const transitionIdToStepOrder = {};

      this.steps.forEach((step) => {
        if (step.id) {
          transitionIdToStepOrder[step.id] = step.step_order;
        }
      });

      if (
        Array.isArray(this.flow.history_by_step) &&
        this.flow.history_by_step.length
      ) {
        this.flow.history_by_step.forEach((step) => {
          const stepOrder = step.step_order || 1;
          const bucket = this.ensureHistoryStep(stepMap, stepOrder);
          bucket.step_name = step.step_name || bucket.step_name;

          (step.items || []).forEach((item) => {
            bucket.items.push({
              id: item.id,
              type: item.type,
              text: item.text || item.comment || "",
              original_name: item.original_name,
              mime: item.mime,
              size: item.size,
              created_at: item.created_at || null,
              user_name: item.user_name || item.created_by_name || "—",
            });
          });
        });

        this.historyByStep = Object.values(stepMap)
          .sort((a, b) => (a.step_order || 0) - (b.step_order || 0));

        return;
      }

      const comments = Array.isArray(this.flow.comments)
        ? this.flow.comments
        : [];

      comments.forEach((comment) => {
        const stepOrder = transitionIdToStepOrder[comment.transition_id] || 1;
        const bucket = this.ensureHistoryStep(stepMap, stepOrder);

        bucket.items.push({
          id: comment.id,
          type: "comment",
          text: comment.comment || comment.text || "",
          user_name:
            comment.user_name ||
            comment.created_by_name ||
            comment.user?.name ||
            "—",
          created_at: comment.created_at || null,
        });
      });

      this.existingFiles.forEach((file) => {
        const stepOrder = transitionIdToStepOrder[file.transition_id] || 1;
        const bucket = this.ensureHistoryStep(stepMap, stepOrder);

        bucket.items.push({
          id: file.id,
          type: "file",
          original_name: file.original_name,
          mime: file.mime,
          size: file.size,
          created_at: file.created_at || null,
          user_name:
            file.user_name ||
            file.uploaded_by_name ||
            file.uploadedBy?.name ||
            "—",
        });
      });

      this.historyByStep = Object.values(stepMap)
        .sort((a, b) => (a.step_order || 0) - (b.step_order || 0));
    },

    isDone(s) {
      if (s.finished_at) return true;
      if (
        this.flow.status === "done" ||
        this.flow.status === "done_with_pending" ||
        this.flow.status === "rejected" ||
        this.flow.status === "cancelled"
      ) {
        return (s.step_order || 0) <= this.currentStepOrder;
      }
      return (s.step_order || 0) < this.currentStepOrder;
    },

    isCurrent(s) {
      if (s.finished_at) return false;
      if (
        this.flow.status === "done" ||
        this.flow.status === "done_with_pending" ||
        this.flow.status === "rejected" ||
        this.flow.status === "cancelled"
      )
        return false;
      return (s.step_order || 0) === this.currentStepOrder;
    },

    stepStateClass(s) {
      if (this.isDone(s)) return s.left_pending ? "st-warn" : "st-done";
      if (this.isCurrent(s))
        return this.hasPendingPredecessor(s) ? "st-warn" : "st-current";
      return "st-future";
    },

    stepTitle(s) {
      if ((s.step_order || 0) > this.currentStepOrder && s.requires_approval) {
        return "Aprovação";
      }
      return s.name || "Sem nome";
    },

    stepCompletedMeta(step) {
      const stepOrder = step?.step_order || 0;
      if (!stepOrder) return null;

      const historyStep = this.historyByStep.find(
        (item) => (item.step_order || 0) === stepOrder
      );

      if (
        !historyStep ||
        !Array.isArray(historyStep.items) ||
        !historyStep.items.length
      ) {
        return null;
      }

      const items = [...historyStep.items].sort((a, b) => {
        const da = a?.created_at ? new Date(a.created_at).getTime() : 0;
        const db = b?.created_at ? new Date(b.created_at).getTime() : 0;
        return db - da;
      });

      return items[0] || null;
    },

    prettySize(bytes) {
      if (!bytes && bytes !== 0) return "";
      const kb = bytes / 1024;
      if (kb < 1024) return `${kb.toFixed(0)} KB`;
      return `${(kb / 1024).toFixed(2)} MB`;
    },

    openSelectedFile(file) {
      try {
        const blobUrl = window.URL.createObjectURL(file);
        window.open(blobUrl, "_blank");

        setTimeout(() => {
          window.URL.revokeObjectURL(blobUrl);
        }, 60000);
      } catch (e) {
        console.error(e);
        this.error = "Não consegui abrir o arquivo selecionado.";
      }
    },

    async openExistingFile(file) {
      try {
        this.error = "";

        const apiBase = this.$store.state.api;

        const response = await this.$http.get(
          apiBase + "flow-files/" + file.id + "/download",
          {
            responseType: "blob",
          }
        );

        const blob = new Blob([response.data], {
          type: file.mime || "application/octet-stream",
        });

        const blobUrl = window.URL.createObjectURL(blob);
        window.open(blobUrl, "_blank");

        setTimeout(() => {
          window.URL.revokeObjectURL(blobUrl);
        }, 60000);
      } catch (e) {
        console.error(e);
        this.error =
          e?.response?.data?.message || "Não consegui abrir o arquivo.";
      }
    },

    openFinishPicker() {
      this.$refs.finishFile.click();
    },

    handleFinishFiles(e) {
      this.pdfError = "";
      const list = Array.from(e.target.files || []);

      for (const f of list) {
        this.finishForm.files.push(f);
      }

      e.target.value = "";
    },

    removeFinishFile(idx) {
      this.finishForm.files.splice(idx, 1);
    },

    async submitCurrentStepUpdate({ advanceAfterSave = false } = {}) {
      this.error = "";
      this.pdfError = "";

      if (this.currentStepRequiresApproval) {
        this.error = "Esta etapa exige aprovação. Use o Painel de Aprovação.";
        return;
      }

      const desc = (this.finishForm.description || "").trim();
      if (!advanceAfterSave && !desc && !this.finishForm.files.length) {
        this.error = "Preencha: descrição ou anexos.";
        return;
      }

      try {
        this.saving = true;

        const id = this.$route.params.id;
        const apiBase = this.$store.state.api;
        const isFinalSave = this.isLastStep && advanceAfterSave;

        const fd = new FormData();
        fd.append("new_description", this.finishForm.description || "");

        for (const f of this.finishForm.files) {
          fd.append("attachments[]", f);
        }

        await this.$http.post(apiBase + "flows/" + id + "/complement", fd, {
          headers: { "Content-Type": "multipart/form-data" },
        });

        let advancedFlow = null;
        if (advanceAfterSave) {
          const advanceRes = await this.$http.post(
            apiBase + "flows/" + id + "/advance"
          );
          advancedFlow = advanceRes?.data || null;
        }

        if (isFinalSave) {
          this.finishForm = { description: "", files: [] };
          this.pdfError = "";
          const message =
            advancedFlow?.status === "done_with_pending"
              ? "Última etapa concluída. O fluxo ficará com status \"Concluído com pendência\" até que a(s) etapa(s) marcada(s) como pendente sejam reabertas e concluídas."
              : "Fluxo concluído com sucesso!";
          swal("Sucesso", message, "success").then(() => {
            this.$router.push("/Flow");
          });
          return;
        }

        await this.loadFlow();
        await this.loadNotifications();
        this.finishForm = { description: "", files: [] };
        this.pdfError = "";

        swal(
          "Sucesso",
          advanceAfterSave
            ? "Etapa finalizada com sucesso!"
            : "Atualização salva com sucesso!",
          "success"
        );
      } catch (e) {
        console.error("STEP UPDATE ERROR:", e?.response || e);
        this.error =
          e?.response?.data?.message ||
          e?.response?.data?.error ||
          JSON.stringify(e?.response?.data) ||
          (advanceAfterSave
            ? "Erro ao finalizar etapa."
            : "Erro ao salvar atualização.");
      } finally {
        this.saving = false;
      }
    },

    async saveCurrentUpdate() {
      await this.submitCurrentStepUpdate({ advanceAfterSave: false });
    },

    async finalizeCurrentStep() {
      await this.submitCurrentStepUpdate({ advanceAfterSave: true });
    },

    async approveFlow() {
      try {
        if (!this.currentApproval?.id) {
          this.error = "Aprovação atual não encontrada.";
          return;
        }

        this.error = "";
        const apiBase = this.$store.state.api;
        const isFinalApproval = this.isLastStep;

        await this.$http.post(
          apiBase + "flow-approvals/" + this.currentApproval.id + "/approve"
        );

        if (isFinalApproval) {
          alert("Fluxo concluído com sucesso!");
          this.$router.push("/Flow");
          return;
        }

        alert("Aprovação realizada com sucesso!");

        try {
          await this.loadFlow();
          await this.loadNotifications();
        } catch (reloadError) {
          console.error("RELOAD ERROR:", reloadError?.response || reloadError);
        }
      } catch (e) {
        console.error("APPROVE ERROR:", e?.response || e);
        this.error =
          e?.response?.data?.message ||
          e?.response?.data?.error ||
          JSON.stringify(e?.response?.data) ||
          "Erro ao aprovar.";
      }
    },

    openRejectBox() {
      this.error = "";

      if (!this.currentApproval?.id) {
        this.error = "Aprovação atual não encontrada.";
        return;
      }

      const lastPreviousStep = this.returnStepOptions.length
        ? this.returnStepOptions[this.returnStepOptions.length - 1]
        : null;

      this.rejectForm = {
        comment: "",
        rejection_type: "step",
        return_to_transition_id: lastPreviousStep ? lastPreviousStep.id : "",
      };

      this.showRejectBox = true;
    },

    cancelRejectBox() {
      this.showRejectBox = false;
      this.rejectForm = {
        comment: "",
        rejection_type: "step",
        return_to_transition_id: "",
      };
    },

    async confirmRejectFlow() {
      try {
        if (!this.currentApproval?.id) {
          this.error = "Aprovação atual não encontrada.";
          return;
        }

        if (!this.rejectForm.comment.trim()) {
          this.error = "Informe o motivo da reprovação.";
          return;
        }

        if (
          this.rejectForm.rejection_type === "step" &&
          !this.rejectForm.return_to_transition_id
        ) {
          this.error = "Selecione a etapa de retorno.";
          return;
        }

        this.error = "";
        const apiBase = this.$store.state.api;

        await this.$http.post(
          apiBase + "flow-approvals/" + this.currentApproval.id + "/reject",
          {
            comment: this.rejectForm.comment,
            rejection_type: this.rejectForm.rejection_type,
            return_to_transition_id:
              this.rejectForm.rejection_type === "step"
                ? this.rejectForm.return_to_transition_id
                : null,
          }
        );

        alert("Reprovação realizada com sucesso!");
        this.cancelRejectBox();

        try {
          await this.loadFlow();
        } catch (reloadError) {
          console.error("RELOAD ERROR:", reloadError?.response || reloadError);
        }
      } catch (e) {
        console.error("REJECT ERROR:", e?.response || e);
        this.error =
          e?.response?.data?.message ||
          e?.response?.data?.error ||
          JSON.stringify(e?.response?.data) ||
          "Erro ao rejeitar.";
      }
    },

    cancel() {
      this.$router.push("/Flow");
    },
  },
};
</script>

<style scoped>
.bread {
  font-size: 12px;
  color: #6b7280;
  font-weight: 700;
}

.sep2 {
  margin: 0 6px;
  color: #9ca3af;
}

.page-title {
  font-weight: 700;
  color: #111827;
}

.lbl {
  font-weight: 800;
  color: #374151;
  margin-bottom: 6px;
  display: inline-block;
}

.text-area-sm {
  min-height: 90px;
  resize: vertical;
  padding-top: 10px;
}

.reject-box {
  margin-top: 14px;
  padding: 12px;
  border: 1px solid #fecaca;
  background: #fff7f7;
  border-radius: 12px;
}

.form-footer {
  position: sticky;
  bottom: 0;
  background: #fff;
  padding: 14px 0;
  border-top: 1px solid #e5e7eb;
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 18px;
}

.file-link {
  cursor: pointer;
  color: #1d4ed8;
  text-decoration: underline;
}

/* ---------- Header card ---------- */

.header-card {
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  padding: 18px 20px;
  margin-bottom: 16px;
}

.header-top {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
}

.header-top-main {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}

.flow-name {
  font-weight: 900;
  font-size: 18px;
  color: #111827;
  margin: 0;
}

.flow-status-badge {
  font-size: 11px;
  font-weight: 800;
  padding: 4px 10px;
  border-radius: 999px;
  white-space: nowrap;
}

.flow-status-badge.fs-in_progress {
  background: #fdf3e3;
  color: #9a5b0a;
}

.flow-status-badge.fs-waiting_approval {
  background: #eef2ff;
  color: #3730a3;
}

.flow-status-badge.fs-done {
  background: #eaf6ec;
  color: #1e7a34;
}

.flow-status-badge.fs-done_with_pending {
  background: #fef3c7;
  color: #9a5b0a;
}

.flow-status-badge.fs-rejected,
.flow-status-badge.fs-cancelled {
  background: #fef2f2;
  color: #b91c1c;
}

.tag-pill {
  display: inline-block;
  background: #eef2ff;
  color: #1d4ed8;
  font-size: 12px;
  font-weight: 800;
  padding: 3px 10px;
  border-radius: 6px;
  flex-shrink: 0;
}

.info-grid {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
  margin-top: 16px;
}

.info-chip {
  display: flex;
  align-items: center;
  gap: 10px;
  background: #f9fafb;
  border: 1px solid #f0f1f3;
  border-radius: 10px;
  padding: 8px 14px;
  flex: 1;
  min-width: 180px;
}

.info-chip > .fa {
  color: #9ca3af;
  font-size: 15px;
  width: 16px;
  text-align: center;
  flex-shrink: 0;
}

.info-chip-text {
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.info-label {
  font-size: 10.5px;
  font-weight: 700;
  color: #9ca3af;
  text-transform: uppercase;
  letter-spacing: 0.03em;
}

.info-value {
  font-size: 13px;
  font-weight: 800;
  color: #111827;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.header-description {
  margin-top: 14px;
  background: #f9fafb;
  border: 1px solid #f0f1f3;
  border-radius: 10px;
  padding: 10px 14px;
}

.header-description-label {
  font-size: 10.5px;
  font-weight: 700;
  color: #9ca3af;
  text-transform: uppercase;
  letter-spacing: 0.03em;
}

.header-description-text {
  margin: 4px 0 0;
  font-size: 13px;
  color: #374151;
  white-space: pre-wrap;
  overflow-wrap: break-word;
}

.header-responsible-row {
  margin-top: 12px;
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
}

.header-responsible-row .info-chip {
  flex: 1;
  min-width: 220px;
}

.header-responsible-actions {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}

.progress-wrap {
  margin-top: 18px;
}

.progress-labels {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 12px;
  color: #9ca3af;
  font-weight: 700;
  margin-bottom: 6px;
}

.progress-percent {
  color: #111827;
  font-weight: 900;
  font-size: 13px;
}

.progress-track {
  height: 8px;
  background: #edeff2;
  border-radius: 99px;
  overflow: hidden;
}

.progress-fill {
  height: 100%;
  background: #22c55e;
  border-radius: 99px;
  transition: width 0.3s ease;
}

.progress-fill.pf-waiting_approval {
  background: #6366f1;
}

.progress-fill.pf-done_with_pending {
  background: #f59e0b;
}

.progress-fill.pf-rejected,
.progress-fill.pf-cancelled {
  background: #ef4444;
}

.progress-current {
  margin-top: 8px;
  font-size: 12.5px;
  color: #6b7280;
  font-weight: 600;
}

.progress-current b {
  color: #111827;
  font-weight: 800;
}

.legend {
  display: flex;
  gap: 16px;
  margin-top: 16px;
  padding-top: 14px;
  border-top: 1px solid #f0f1f3;
  flex-wrap: wrap;
}

.legend-item {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  color: #6b7280;
  font-weight: 600;
}

.dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  flex-shrink: 0;
}

.dot-done {
  background: #22c55e;
}

.dot-current {
  background: #f59e0b;
}

.dot-warn {
  background: #f97316;
}

.dot-locked {
  background: #d8dce2;
}

/* ---------- Timeline ---------- */

.timeline {
  display: flex;
  flex-direction: column;
}

.tl-step {
  display: flex;
  gap: 16px;
}

.rail {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 28px;
  flex-shrink: 0;
}

.node {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 900;
  font-size: 12px;
  flex-shrink: 0;
  border: 2px solid transparent;
  color: #9ca3af;
  background: #fff;
  transition: box-shadow 0.2s ease;
}

.node.st-done {
  background: #22c55e;
  color: #fff;
  border-color: #22c55e;
}

.node.st-current {
  background: #fff;
  color: #d97706;
  border-color: #f59e0b;
  box-shadow: 0 0 0 4px rgba(245, 158, 11, 0.15);
}

.node.st-warn {
  background: #fff;
  color: #ea580c;
  border-color: #f97316;
}

.node.st-future {
  background: #fff;
  color: #9aa3af;
  border-color: #d8dce2;
}

.connector {
  width: 2px;
  flex: 1;
  min-height: 14px;
  background: #d8dce2;
}

.connector.st-done {
  background: #22c55e;
}

.connector.st-warn {
  background: repeating-linear-gradient(
    to bottom,
    #f97316 0 4px,
    transparent 4px 8px
  );
}

.tl-body {
  flex: 1;
  padding-bottom: 20px;
  min-width: 0;
}

.tl-card {
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  padding: 14px 16px;
  margin-top: -2px;
}

.tl-card.st-current {
  border-color: #fcd34d;
  background: #fffbeb;
}

.tl-card.st-warn {
  border-color: #fb923c;
  background: #fff7ed;
}

.tl-card.st-done {
  border-color: #86efac;
  background: #f0fdf4;
}

.tl-card.st-future {
  border-style: dashed;
  background: #f9fafb;
}

.tl-head {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 12px;
  flex-wrap: wrap;
}

.tl-title {
  font-weight: 900;
  font-size: 14.5px;
  margin: 0;
  color: #111827;
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

.tl-area {
  display: inline-block;
  font-size: 11px;
  font-weight: 700;
  color: #6b7280;
  background: #f0f1f3;
  padding: 2px 8px;
  border-radius: 5px;
  margin-top: 4px;
}

.status-pill {
  font-size: 11px;
  font-weight: 800;
  padding: 3px 9px;
  border-radius: 99px;
  white-space: nowrap;
}

.status-pill.st-done {
  background: #eaf6ec;
  color: #1e7a34;
}

.status-pill.st-current {
  background: #fdf3e3;
  color: #9a5b0a;
}

.status-pill.st-warn {
  background: #ffedd5;
  color: #c2410c;
}

.status-pill.st-future {
  background: #f0f1f3;
  color: #9aa3af;
}

.tl-meta {
  font-size: 12px;
  color: #6b7280;
  font-weight: 700;
  margin: 6px 0 0;
}

.tl-info-row {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  margin-top: 8px;
}

.tl-info-chip {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  font-weight: 700;
  color: #6b7280;
  background: #f9fafb;
  border-radius: 999px;
  padding: 4px 10px;
}

.tl-info-chip .fa {
  font-size: 12px;
  color: #9ca3af;
}

.tl-info-chip-done {
  color: #1e7a34;
  background: #eaf6ec;
}

.tl-info-chip-done .fa {
  color: #1e7a34;
}

.guidance {
  margin-top: 10px;
  font-size: 12.5px;
  color: #9a5b0a;
  background: #fdf3e3;
  border-radius: 8px;
  padding: 9px 12px;
  display: flex;
  gap: 8px;
  align-items: flex-start;
}

.approval-inline {
  margin-top: 12px;
  padding-top: 10px;
  border-top: 1px solid #e5e7eb;
}

.form-required-note {
  font-size: 12.5px;
  color: #9a5b0a;
  background: #fdf3e3;
  border-radius: 8px;
  padding: 9px 12px;
}

.tl-form-summary {
  margin-top: 10px;
  padding: 4px 14px;
  background: rgba(255, 255, 255, 0.6);
  border: 1px solid rgba(17, 24, 39, 0.08);
  border-radius: 10px;
}

.tl-form-title {
  font-size: 12px;
  font-weight: 800;
  color: #374151;
  padding: 10px 0;
  display: flex;
  align-items: center;
  gap: 6px;
  border-bottom: 1px solid rgba(17, 24, 39, 0.06);
}

.tl-form-req-tag {
  font-size: 10px;
  font-weight: 800;
  color: #b91c1c;
  background: #fef2f2;
  border-radius: 999px;
  padding: 1px 8px;
}

.tl-form-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  font-size: 12.5px;
  color: #374151;
  padding: 9px 0;
}

.tl-form-row + .tl-form-row {
  border-top: 1px solid rgba(17, 24, 39, 0.05);
}

.tl-form-q {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #6b7280;
  font-weight: 700;
  min-width: 0;
}

.tl-form-q .fa {
  color: #9ca3af;
  width: 14px;
  text-align: center;
  flex-shrink: 0;
}

.tl-form-a {
  font-weight: 800;
  color: #111827;
  text-align: right;
  flex-shrink: 0;
}

.tl-form-a.is-empty {
  color: #c1c7d0;
  font-weight: 600;
  font-style: italic;
}

.tl-form-a-bool {
  font-size: 11px;
  font-weight: 800;
  padding: 2px 10px;
  border-radius: 999px;
  flex-shrink: 0;
}

.tl-form-a-bool.is-yes {
  color: #1e7a34;
  background: #eaf6ec;
}

.tl-form-a-bool.is-no {
  color: #b91c1c;
  background: #fef2f2;
}

.tl-form-a-file {
  color: #1d4ed8;
  font-weight: 700;
  flex-shrink: 0;
  white-space: nowrap;
}

.answer-question {
  margin-bottom: 14px;
}

.answer-question .req {
  color: #dc2626;
}

.locked-note {
  font-size: 13px;
  color: #9aa3af;
  font-style: italic;
  margin-top: 10px;
}

.tl-actions {
  display: flex;
  gap: 8px;
  margin-top: 12px;
  flex-wrap: wrap;
  align-items: center;
}

.pill-next {
  font-size: 11px;
  font-weight: 900;
  padding: 4px 10px;
  border-radius: 999px;
  border: 1px solid #fcd34d;
  background: #fde68a;
  color: #92400e;
}

/* ---------- Thread ---------- */

.thread {
  margin-top: 12px;
  border-top: 1px solid #e5e7eb;
  padding-top: 10px;
}

.thread-toggle {
  font-size: 12.5px;
  color: #6b7280;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 6px;
  user-select: none;
  font-weight: 700;
}

.thread-toggle .count {
  background: #f0f1f3;
  color: #6b7280;
  font-size: 11px;
  padding: 1px 7px;
  border-radius: 99px;
}

.thread-body {
  margin-top: 10px;
}

.tl-comment {
  display: flex;
  gap: 10px;
  margin-bottom: 10px;
}

.avatar {
  width: 26px;
  height: 26px;
  border-radius: 50%;
  background: #e4f3f0;
  color: #0d6e63;
  font-size: 11px;
  font-weight: 800;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.tl-comment-main {
  flex: 1;
  background: #f9fafb;
  border-radius: 8px;
  padding: 8px 12px;
  min-width: 0;
}

.tl-comment-head {
  display: flex;
  gap: 8px;
  align-items: center;
  margin-bottom: 2px;
}

.tl-comment-author {
  font-size: 12.5px;
  font-weight: 800;
  color: #111827;
}

.tl-comment-time {
  font-size: 11px;
  color: #9aa3af;
  margin-left: auto;
}

.tl-comment-text {
  font-size: 13px;
  color: #111827;
  white-space: pre-wrap;
  overflow-wrap: break-word;
}

.attachment-chip {
  margin-top: 2px;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  background: #e4f3f0;
  padding: 4px 10px;
  border-radius: 7px;
}

.new-comment {
  margin-top: 10px;
}

.nc-actions {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
  margin-top: 8px;
}

.nc-attach-preview {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
  font-size: 12px;
  color: #6b7280;
}

.nc-file-chip {
  background: #f0f1f3;
  padding: 3px 8px;
  border-radius: 6px;
  font-size: 12px;
}

.nc-file-chip .remove {
  cursor: pointer;
  color: #9a5b0a;
  font-weight: 700;
  margin-left: 6px;
}

/* ---------- Bell ---------- */

.bell-wrap {
  position: relative;
}

.bell-btn {
  position: relative;
}

.bell-badge {
  position: absolute;
  top: -6px;
  right: -6px;
  background: #e1a03a;
  color: #fff;
  font-size: 10px;
  font-weight: 700;
  min-width: 16px;
  height: 16px;
  border-radius: 999px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 3px;
}

.bell-panel {
  position: absolute;
  top: 36px;
  right: 0;
  width: 320px;
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
  z-index: 30;
  max-height: 360px;
  overflow: auto;
}

.bell-head {
  padding: 10px 14px;
  font-size: 13px;
  font-weight: 800;
  color: #111827;
  border-bottom: 1px solid #e5e7eb;
}

.bell-empty {
  padding: 18px 14px;
  font-size: 13px;
  color: #9ca3af;
  text-align: center;
}

.notif-item {
  padding: 10px 14px;
  border-bottom: 1px solid #f1f5f9;
  font-size: 12.5px;
}

.notif-item:last-child {
  border-bottom: none;
}

.notif-title {
  font-weight: 700;
  color: #111827;
  margin-bottom: 2px;
}

.notif-meta {
  color: #9ca3af;
  font-size: 11.5px;
}

@media (max-width: 768px) {
  .tl-actions {
    flex-direction: column;
    align-items: stretch;
  }
}
</style>
